import { render, staticRenderFns } from "./IconFilePpt.vue?vue&type=template&id=1a98efb7&"
import script from "./IconFilePpt.vue?vue&type=script&lang=js&"
export * from "./IconFilePpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports